import { CircularProgress } from '@mui/material'
import type { OwnershipFormFieldProps } from '@zealth/core/formFields/types'
import { useOwnershipOptions } from '@zealth/core/formFields/useOwnershipOptions'

import { DropdownFormField } from './DropdownFormField'

export const OwnershipFormField = ({ showJoint }: OwnershipFormFieldProps) => {
  const { isLoading, options } = useOwnershipOptions({ showJoint })

  if (isLoading) {
    return <CircularProgress size={20} />
  }

  return <DropdownFormField options={options} label="" />
}
